import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { PageHeader, Button, Tabs, Icon, Layout, Col, Row, Card } from 'antd'
import moment from 'moment'

import { policies, companies } from '@services/api'

import Details from './Details'
import Privileges from './Privileges'
import Files from './Files'
import EditDescription from './EditDescription'
import RightsParameters from './RightsParameters'
import Collections from './Collections'
import { authStore } from 'store'
import SimilarPolicies from './SimilarPolicies'

@inject((store: any) => {
    const {
        categoriesStore,
        authStore,
        providerStore,
        rightsStore,
        parametersStore,
        rightsParametersStore,
        paramGroupsStore,
        policyCollectionsStore,
        policiesStore
    } = store
    return {
        categoriesStore,
        authStore,
        providerStore,
        rightsStore,
        parametersStore,
        rightsParametersStore,
        paramGroupsStore,
        policyCollectionsStore,
        policiesStore
    }
})
@observer
class Policy extends Component<any, any> {
    state: any = {
        policy: {},
        editPolicy: {},
        files: [],
        loading: true,
        disableEdit: true,
        categoriesList: [],
        companiesList: [],
        parentsTree: {},
        errors: {}
    }

    componentDidMount() {
        const { policy_id } = this.props.computedMatch.params
        this.updatePolicy(policy_id)
    }

    updateDetails = field => {
        const { name, value } = field
        this.setState(prevState => ({ ...prevState, editPolicy: { ...prevState.editPolicy, [name]: value } }))
    }

    updatePolicy = async id => {
        const { categoriesStore, providerStore } = this.props
        const { policy, parentsTree, files } = (await policies.getPolicy({ policy_id: id })).data
        await categoriesStore.updateCategoriesList('POLICY', ['name', 'id', 'parent_id'])
        await categoriesStore.updateSelectedByCategory(policy['category_id'])
        await providerStore.getProviders()
        await providerStore.setValue(policy.provider_name)
        const hmoCompanies = (await companies.getHmoList()).data

        this.setState({
            loading: false,
            policy,
            files,
            hmoCompanies,
            editPolicy: policy,
            parentsTree: parentsTree[0]
        })
    }

    toggleEditing = async status => {
        const { policy } = this.state
        await this.props.categoriesStore.updateSelectedByCategory(policy['category_id'])
        this.setState({ disableEdit: status, editPolicy: { ...policy }, errors: {} })
    }

    setError = async (field, error) => {
        this.setState(prevState => ({ ...prevState, errors: { ...prevState.errors, [field]: error } }))
    }

    validatePolicy = async () => {
        const { editPolicy } = this.state
        if (!editPolicy['name']) {
            this.setError('name', 'שדה זה הוא שדה חובה')
            return false
        }
        if (editPolicy['type'] === 'GROUP') {
            if (!editPolicy['provider_id']) {
                this.setError('providerError', 'במידה והפוליסה סומנה כקבוצתית עליך לבחור ספק')
                return false
            }
        }
        if (editPolicy['type'] === 'SHABAN' && !editPolicy['hmo_id']) {
            this.setError('shabanError', 'בפוליסת שב"ן חובה לבחור שיוך לקופת חולים')
            return false
        }
        if (!editPolicy['company_id']) {
            this.setError('company', 'שדה זה הוא שדה חובה')
            return false
        }
        if (!editPolicy['category_id']) {
            this.setError('category', 'עליך לבחור קטגוריה')
            return false
        }
        if (editPolicy['expiration_date'] && !editPolicy['release_date']) {
            this.setError('releaseDateError', 'חובה לבחור תאריך תחילת שיווק פוליסה במידה ונבחר תאריך סיום שיווק')
            return false
        }
        if (editPolicy['expiration_date'] && editPolicy['expiration_date'] < editPolicy['release_date']) {
            this.setError('releaseDateError', 'תאריך שחרור הפוליסה לא יכול להיות גדול יותר מתאריך סיום שיווק הפוליסה')
            return false
        }
        return true
    }

    policyLock = async () => {
        const { locked, id } = this.state.editPolicy
        await policies.updateField({ id, name: 'locked', value: !locked })
        await this.updatePolicy(id)
        this.toggleEditing(true)
    }

    tabChanged = async tabType => {
        const { rightsStore, paramGroupsStore, policyCollectionsStore } = this.props
        const { right_param_set_id, id } = this.state.policy

        if (tabType === 'RIGHTS_PARAMETERS') {
            await paramGroupsStore.getList()
            if (right_param_set_id) {
                await rightsStore.getRightsList({ right_param_set_id, policy_id: id })
                rightsStore.resetFilters()
            } else {
                await rightsStore.resetRights()
            }
        }
        if (tabType === 'POLICY_COLLECTIONS') {
            await policyCollectionsStore.getList(this.state.policy.id)
        }
    }

    submitPolicy = async () => {
        const { policy_id } = this.props.computedMatch.params
        if (await this.validatePolicy()) {
            try {
                await policies.updatePolicy(this.state.editPolicy)
                await this.updatePolicy(policy_id)
                this.toggleEditing(true)
            } catch (e) {
                if (e.response.status === 406) {
                    const { insuranceCases, hmoCases } = e.response.data
                    const message = `לא ניתן לעדכן קטגוריה וסוג פוליסה כיוון שנמצאו - ${
                        !!insuranceCases ? `${insuranceCases} תיקי ביטוח, ` : ''
                    }${!!hmoCases ? `${hmoCases} תיקי שב"ן, ` : ''}תחת פוליסה זו`
                    this.setError('server', message)
                } else {
                    this.setError('server', `שגיאה ${e.response.status} בחיבור בשרת`)
                }
            }
        }
    }

    render() {
        const { policy, loading, disableEdit, files, editPolicy } = this.state
        const { policy_id } = this.props.computedMatch.params
        let editingActions

        if (
            authStore.roles.includes('admin') ||
            authStore.roles.includes('moderator') ||
            authStore.roles.includes('developer')
        ) {
            editingActions = disableEdit ? (
                <Button onClick={() => this.toggleEditing(false)} style={{ margin: 0 }}>
                    <Icon type="edit" /> ערוך פרטים
                </Button>
            ) : (
                <Fragment>
                    <Button onClick={() => this.policyLock()}>
                        {!editPolicy['locked'] ? (
                            <Fragment>
                                <Icon type="lock" />
                                <span>נעילה</span>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <Icon type="unlock" />
                                <span>שחרור</span>
                            </Fragment>
                        )}
                    </Button>
                    <Button onClick={() => this.toggleEditing(true)}>
                        <Icon type="stop" />
                        <span>ביטול</span>
                    </Button>
                    {!editPolicy['locked'] ? (
                        <Button onClick={() => this.submitPolicy()} type="primary" style={{ margin: 0 }}>
                            <Icon type="check" />
                            <span>שמור שינויים</span>
                        </Button>
                    ) : (
                        ''
                    )}
                </Fragment>
            )
        }

        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title={`${policy['name']} (${policy['id']})`}
                    subTitle={`עדכון אחרון - ${moment(policy['updated_at']).format('DD/MM/YYYY HH:mm')} | ${
                        policy['updated_by']
                    }`}
                />
                <Tabs onChange={type => this.tabChanged(type)} type="card" style={{ overflowY: 'auto' }}>
                    <Tabs.TabPane tab="פרטי הפוליסה" key="POLICY_DETAILS">
                        <Row gutter={10} style={{ padding: '1rem' }}>
                            <Col span={8}>
                                <Card
                                    headStyle={{ backgroundColor: '#dadce0' }}
                                    bodyStyle={{ padding: '0.7rem' }}
                                    loading={loading}
                                    title={
                                        <div>
                                            <span style={{ float: 'left', margin: '-0.3rem 0' }}>{editingActions}</span>
                                            פרטי הפוליסה
                                        </div>
                                    }
                                >
                                    <Details {...this.state} detailsChanged={field => this.updateDetails(field)} />
                                </Card>
                            </Col>
                            <Col span={16}>
                                <Card
                                    headStyle={{ backgroundColor: '#dadce0' }}
                                    bodyStyle={{ padding: '0.7rem' }}
                                    style={{ marginBottom: '1rem' }}
                                    loading={loading}
                                    title="תיאור הפוליסה"
                                >
                                    {policy ? (
                                        <EditDescription
                                            policy_id={policy['id']}
                                            description={policy['short_description']}
                                            disable={!!editPolicy.locked}
                                            descriptionUpdated={() => this.updatePolicy(policy['id'])}
                                        />
                                    ) : (
                                        ''
                                    )}
                                </Card>
                                <Privileges policy_id={policy_id} disable={!!editPolicy.locked} />
                                <Files
                                    list={files}
                                    policy_id={policy_id}
                                    loading={loading}
                                    disable={!!editPolicy.locked}
                                    fileUpdated={() => this.updatePolicy(policy_id)}
                                />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane style={{ overflow: 'auto' }} tab="כיסויים ופרמטרים" key="RIGHTS_PARAMETERS">
                        <Row>
                            <Col>
                                <RightsParameters updatePolicy={id => this.updatePolicy(id)} policy={policy} />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane style={{ overflow: 'auto' }} tab="זכויות מכל הבריאות" key="POLICY_COLLECTIONS">
                        <Row>
                            <Col>
                                <Collections updatePolicy={id => this.updatePolicy(id)} policy={policy} />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane style={{ overflow: 'auto' }} tab="פוליסות דומות" key="INSURANCE_CALCULATOR">
                        <Row>
                            <Col>
                                <SimilarPolicies updatePolicy={id => this.updatePolicy(id)} policy={policy} />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>
            </Layout>
        )
    }
}

export default withRouter(Policy)
